/**
 * State used in rendering ImageSwatch
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
